import { useEffect } from 'react';
import { clearToken, getToken, post } from '../api';

export default function Logout() {
    useEffect(() => {
        const runLogout = async () => {
            const token = getToken();

            if (token) {
                try {
                    await post('/auth/logout');
                } catch {
                    // Ignore logout API errors; local session clear still signs the user out.
                }
            }

            clearToken();
            window.location.replace('/login');
        };

        void runLogout();
    }, []);

    return (
        <main className="mx-auto flex min-h-screen max-w-2xl items-center justify-center px-6 py-12">
            <p className="text-sm" style={{ color: 'var(--foreground-muted)' }}>
                Signing you out...
            </p>
        </main>
    );
}
